import {SIDEBAR, MEDIA} from "../../constants";
import {trigger} from "../../../utils/events/trigger";

let timerID = undefined;

export const initAsideSidebar = () => {
	if (window.innerWidth < MEDIA.DESKTOP && !SIDEBAR.isOpened && !document.querySelector(`#state-switch`).checked && !document.querySelector(`div.lightbox`))
	{
		clearTimeout(timerID);
		timerID = setTimeout( () => {
			if (!SIDEBAR.isOpened && !document.querySelector(`#state-switch`).checked && !document.querySelector(`div.lightbox`))
			{
				SIDEBAR.isOpened = true;
				trigger(SIDEBAR.INPUT, `change`, true);
			}
		},10000);
	}
};
